import "../Styles/AboutMe.css";
import React from "react";
import Nikesh_Borkar_Resume from "../Download/Nikesh_Borkar_Resume.pdf";
import logo from "../assets/img_about_me.webp";

export const AboutMe = () => {
  return (
    <div id="aboutMe">
      <div className="aboutMeContainer">
        <h1>About Me</h1>
        <div className="aboutMeDecription">
          <div className="developerImage">
            <img src={logo} alt="developers img" />
          </div>
          <div className="MyDescription">
            <h3>My name is Nikesh Borkar</h3>
            <h4>Mern-Stack developer</h4>
            <div className="aboutmeDetails">
              I am a Full stack web developer. I have made some projects using
              HTML, CSS, Javascript, React, Redux, NodeJS, MongoDB, Express
              still learning...
              <br></br>
              <br></br>I am passionate about solving real-world problems in the
              field of web development and software engineering. Eager to be a
              part of a team which gives me ability to learn and grow . My
              hobbies are Watching movies, Travelling, listening music
            </div>
            <div className="buttons">
              <button>
                <a href="#contactPageSection">Hire me</a>
              </button>
              <button>
                <a href={Nikesh_Borkar_Resume} download>
                  Resume
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
